import { render, staticRenderFns } from "./medicine-order-details-program-weighnow.vue?vue&type=template&id=11b46398&scoped=true"
import script from "./medicine-order-details-program-weighnow.vue?vue&type=script&lang=js"
export * from "./medicine-order-details-program-weighnow.vue?vue&type=script&lang=js"
import style0 from "./medicine-order-details-program-weighnow.vue?vue&type=style&index=0&id=11b46398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b46398",
  null
  
)

export default component.exports